import React from 'react';

const AboutSection: React.FC = () => {
  return (
    <div className="bg-white py-16 px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        {/* Mission */}
        <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-6">
          Our Mission
        </h2>
        <p className="text-lg text-gray-600 mb-10">
          At LoadDrive, our mission is to simplify employee onboarding and document verification. 
          We help companies manage employee registration, review documents, and maintain 
          organized records � all from one secure platform.
        </p>

{/* Mission */}
        <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-6">
          Our Mission
        </h2>
        <p className="text-lg text-gray-600 mb-10">
          At LoadDrive, our mission is to simplify carrier onboarding and compliance management.
          We help freight brokers collect documents, verify insurance, and maintain
          organized carrier records � all from one secure platform.
        </p>

        {/* Vision */}
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          Our Vision
        </h3>
        <p className="text-lg text-gray-600 mb-10">
          We believe carrier onboarding should be straightforward. By providing clear
          workflows, secure document storage, and compliance tracking, LoadDrive empowers
          brokers to focus on moving freight instead of chasing paperwork.
        </p>

        {/* Who We Are */}
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          Who We Are
        </h3>
        <p className="text-lg text-gray-600 mb-6">
          LoadDrive is a <span className="font-semibold">Carrier Onboarding & Compliance Platform</span> designed
          for freight brokers who need to streamline how they register and verify carriers.
          LoadDrive brings the entire carrier onboarding workflow together in one secure, easy-to-use platform.
        </p>

        <div className="text-left inline-block mx-auto mb-6">
          <h4 className="font-semibold text-gray-900 mb-3">What LoadDrive Does:</h4>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Carrier registration with broker codes</li>
            <li>COI, W9, MC/DOT document collection</li>
            <li>Insurance expiration tracking</li>
            <li>Document approval/rejection workflow</li>
            <li>Carrier-level compliance status</li>
            <li>Request additional documents anytime</li>
          </ul>
        </div>

        <p className="text-lg text-gray-600">
          By centralizing the onboarding workflow - from carrier registration to 
          document approval - LoadDrive helps brokers onboard carriers faster and 
          maintain organized compliance records with complete audit visibility.
        </p>
      </div>
    </div>
  );
};

export default AboutSection;
